import { doc, updateDoc } from "firebase/firestore";
import { db } from "../firebaseConfig";
import moment from "moment";
import { MESSAGE } from "../common/message";

// Utility function to read a file as DataURL
const readFileAsDataURL = (file: File): Promise<string> => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onloadend = () => resolve(reader.result as string);
      reader.onerror = reject;
      reader.readAsDataURL(file);
    });
  };
  
  // Utility function to load an image
  const loadImage = (src: string): Promise<HTMLImageElement> => {
    return new Promise((resolve, reject) => {
      const img = new Image();
      img.onload = () => resolve(img);
      img.onerror = reject;
      img.src = src;
    });
  };
  
  // Utility function to create a compressed blob from an image
  const createCompressedBlob = (img: HTMLImageElement, fileType: string, quality: number): Promise<Blob | null> => {
    return new Promise((resolve) => {
      const canvas = document.createElement('canvas');
      const ctx = canvas.getContext('2d');
      if (!ctx) {
        resolve(null);
        return;
      }
      canvas.width = img.width;
      canvas.height = img.height;
      ctx.drawImage(img, 0, 0);
      canvas.toBlob((blob) => resolve(blob), fileType, quality);
    });
  };
  
  // Main function to compress an image
  export const compressImage = async (file: File, quality: number): Promise<File> => {
    try {
      const dataURL = await readFileAsDataURL(file);
      const img = await loadImage(dataURL);
      const blob = await createCompressedBlob(img, file.type, quality);
  
      if (!blob) {
        throw new Error('Compression failed');
      }
  
      return new File([blob], file.name, { type: file.type });
    } catch (error) {
      return Promise.reject(error);
    }
  };

  export const updateUserOnlineStatusInFirebase = async (isOnline:any) => {
    const updatedData = { 
      isOnline: isOnline,
      time:Date.now(),
    };
  
    try {
      const userDocRef = doc(db,  MESSAGE.userCollection, MESSAGE.adminId)
      await updateDoc(userDocRef, updatedData);
    } catch (error) {
      console.error('Error updating unReadCount:', error);
    }
  }
  export const getChatUserLastSeen = (time:number):string => {
    if (!time) return "";
  
    const timestamp = moment(time);
    const now = moment();
  
    // Determine the status message
    let statusMessage;
  
    const isToday = now.isSame(timestamp, 'day');
    const isYesterday = now.subtract(1, 'day').isSame(timestamp, 'day');
  
    if (isToday) {
      statusMessage = `Last seen today at ${timestamp.format('h:mm A')}`;
    } else if (isYesterday) {
      statusMessage = `Last seen yesterday at ${timestamp.format('h:mm A')}`;
    } else {
      statusMessage = `Last seen ${timestamp.format('D MMM')} at ${timestamp.format('h:mm A')}`;
    }
  
    return statusMessage;
  };

  export const getMonthStartEndDates = (date: Date) => {
    const year = moment(date).year();
    const month = moment(date).month();
  
    // Start of current month
    const start_date = moment({ year, month }).startOf('month').format('YYYY-MM-DD');
  
    // End of current month
    const end_date = moment({ year, month }).endOf('month').format('YYYY-MM-DD');
  
    return { start_date, end_date };
  };
  